"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VirtualizedTable", {
  enumerable: true,
  get: function get() {
    return _VirtualizedTable["default"];
  }
});

var _VirtualizedTable = _interopRequireDefault(require("./VirtualizedTable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }